/* eslint-disable */
import {reactive} from 'vue';
import {declOfNum, forEach, getValue, isEmpty, isFunction, isNil, isObject} from '@/utils/helpers'

// import emitter from 'tiny-emitter/instance';

class ValidateClass {

  constructor(formModel) {
    this.formModel = formModel

    this.data = reactive({
      formRules: {}, // правила валидации
      errors: {}, // ошибки валидации
      googleEventErrorField: null, // событие для google при возникновении ошибки
      progressPercent: 0, // на сколько % заполнена форма - учитываем только обязательные поля
      blurredFields: {}, // поля которые были blurred
      blurredForm: false, // вся форма blurred
      validForm: true, // валидна форма или нет
      validateForm: this.validateForm.bind(this), // провалидировать форму
      validateField: this.validateField.bind(this), // провалидировать поле
      forceValidateForm: this.forceValidateForm.bind(this), // функция валидации формы
      scrollToErrorField: this.scrollToErrorField.bind(this), // прокрутить до поля ошибки
      setGoogleEventErrorField: this.setGoogleEventErrorField.bind(this), // сохраним событие для google dataLayer
      setBlurredField: this.setBlurredField.bind(this)
    })

    this.validateForm()
  }

  // $on (args) {
  //   emitter.on(...args)
  // }
  // $off(args) {
  //   emitter.off(...args)
  // }
  // $emit (args) {
  //   emitter.emit(...args)
  // }

  created() {
    this.validateForm()
  }

  setGoogleEventErrorField(value) {
    this.data.googleEventErrorField = value
  }

  // проскролить до элемента с ошибкой
  scrollToErrorField(offsetTop = 0) {

    const {formRules, errors} = this.data

    let minTopPosition = null
    let minTopEl = null

    forEach(errors, (rules, key) => {

      if (!formRules[key]) {
        return
      }

      const $el = this.getFieldElement(formRules[key])

      if ($el) {
        const offset = $el.offset()

        if (!minTopPosition || minTopPosition > offset.top) {
          minTopPosition = offset.top
          minTopEl = $el
        }
      }
    })

    if (minTopEl) {
      minTopEl.scrollTo(400, -20 + offsetTop)
    }

    return !!minTopPosition
  }

  getFieldElement(rules) {

    let selectorId = null
    let selectorName = null

    forEach(rules, rule => {

      if (isObject(rule) && !isFunction(rule) && rule.selector) {

        if (rule.selector.indexOf('name=') === 0) {

          selectorName = rule.selector.replace('name=', '')

        } else {

          selectorId = rule.selector.replace('#', '')
        }

        return false
      }
    })

    let $el = null

    if (selectorName) {
      $el = document.querySelector(`[name=${selectorName}]`)
    } else if (selectorId) {
      $el = document.querySelector(`#${selectorName}`)
    }

    return $el
  }

  // провалидировать форму принудительно
  forceValidateForm() {
    this.data.blurredForm = true
    this.validateForm()

    return this.data.validForm
  }

  updateValidForm() {
    this.data.validForm = !Object.keys(this.data.errors).length

    // progressPercent
    const {formRules, errors} = this.data

    // провалидированные поля
    let countValidFields = 0
    // все поля обязательные
    let countFields = 0

    for (const field in formRules) {
      if (formRules.hasOwnProperty(field)) {

        if (!~formRules[field].indexOf('required')) {
          continue
        }

        countFields += 1

        if (!errors[field]) {
          countValidFields += 1
        }
      }
    }

    this.data.progressPercent = countFields === 0 ? 0 : (100 * countValidFields) / countFields
  }

  setFormRules(formRules) {
    this.data.formRules = formRules
    this.validateForm()
  }

  // провалидировать всю форму
  validateForm() {

    const {formRules} = this.data

    const {formModel} = this

    this.data.errors = {}

    for (const key in formRules) {
      if (formRules.hasOwnProperty(key)) {
        this.validateField(key)
      }
    }

    // validateFields - для компонентов input2-form select2-form
    // formModel.$emit('validateFields')

    this.updateValidForm()
  }

  // отметим что ушли с поля
  setBlurredField(key) {
    this.data.blurredFields[key] = true
  }

  // получим поле было затронуто или нет
  isBlurredField(key) {
    return this.data.blurredForm || this.data.blurredFields[key] || false
  }

  // провадидируем поле
  validateField(key) {

    const rules = this.data.formRules[key]

    if (!rules) {
      return
    }

    const {formModel} = this

    const value = getValue(formModel, key)

    let fieldError = null

    rules.forEach(rule => {

      if (fieldError) {
        return
      }

      // options
      if (isObject(rule) && !isFunction(rule)) {
        return
      }

      // custom validation
      if (isFunction(rule)) {
        const errorText = rule(value)

        if (errorText) {
          fieldError = errorText || null
        }

        return
      }

      const ruleArg = rule.split('=')

      fieldError = this.validateByRuleGetErrorText(ruleArg[0], value, ruleArg[1])
    })

    if (fieldError) {

      this.data.errors[key] = fieldError

    } else {

      delete this.data.errors[key]
    }

    this.updateValidForm()

    return fieldError
  }

  validateByRuleGetErrorText(rule, value, param) {
    const result = this.validateRule(rule, value, param)

    if (result) {
      return null
    }

    return this.getErrorText(rule, param)
  }

  validateRule(rule, value, param) {

    switch (rule) {
      case 'required':
        return this.validateRequired(value)
      case 'email':
        return this.validateEmail(value)
      case 'numeric':
      case 'number':
        return this.validateNumber(value)
      case 'float':
        return this.validateFloat(value)
      case 'minLength':
        return this.validateMinLength(value, param)
      case 'maxLength':
        return this.validateMaxLength(value, param)
      case 'ruString':
      case 'fio':
        return this.validateRuString(value)
      case 'ruDotString':
        return this.validateRuDotString(value)
      case 'numberRuString':
        return this.validateNumberRuString(value)
      case 'ruDotNumeric':
        return this.validateRuDotNumeric(value)
      case 'ruEnString':
        return this.validateRuEnString(value)
      case 'phone':
        return this.validatePhone(value)
      case 'inn':
        return this.validateInn(value)
      case 'year':
        return this.validateYear(value)
      case 'snils':
        return this.validateSNILS(value)
      case 'date':
        return this.validateDate(value)
      case 'firstUpperCase':
        return this.validateFirstUpperCase(value)
      case 'address':
        return this.validateAddress(value)
      case 'age':
        return this.validateAge(value, param)
      case 'agree':
      case 'personalDataAgree':
      case 'marketingAgree':
        return this.validateAgree(value)
      case 'noSpaceSymbol':
        return this.validateNoSpaceSymbol(value)
      case 'url':
        return this.validateUrl(value)
      default:
        return null
    }
  }

  validateDate(value) {
    if (isNil(value) || isEmpty(value) || value instanceof Date) {
      return true
    }

    let valid = true

    const date = value.split('.')

    if (date.length === 1) {
      return false
    }

    if (date.length === 2) {
      const month = parseInt(date[0])
      const year = parseInt(date[1])

      if (isNaN(month) || isNaN(year)) return false

      if ((month < 1) || (month > 12)) {
        valid = false
      }

    } else if (date.length === 3) {

      const month = parseInt(date[1])
      const day = parseInt(date[0])
      const year = parseInt(date[2])

      if (isNaN(month) || isNaN(day) || isNaN(year)) return false

      if (year > 3000) {
        return false
      }

      if ((month < 1) || (month > 12)) {
        valid = false
      } else if ((day < 1) || (day > 31)) {
        valid = false
      } else if (((month === 4) || (month === 6) || (month === 9) || (month === 11)) && (day > 30)) {
        valid = false
      } else if ((month === 2) && ((year % 400) === 0) && (year % 4 === 0) && ((year % 100) !== 0) && (day > 29)) {
        valid = false
      } else if ((month === 2) && ((year % 100) === 0) && (year % 400 !== 0) && (day > 28)) {
        valid = false
      } else if ((month === 2) && (day > 28) && (year % 4 !== 0)) {
        valid = false
      } else if ((month === 2) && day > 29) valid = false
    }

    return valid
  }

  validateAgree(value) {
    return !!~~value
  }

  validateAge(value, age) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    const msInYear = 3.15576e+10

    const [day, month, year] = value.split('.')

    const getAge = birthDate => Math.floor((new Date() - new Date(birthDate).getTime()) / msInYear)

    return getAge(`${year}-${month}-${day}`) >= age
  }

  validateFirstUpperCase(value) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    if (!value[0]) {
      return true
    }

    const firstChar = value[0]

    return firstChar === firstChar.toUpperCase()
  }

  validateNoSpaceSymbol(value) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    return String(value).match(' ') === null
  }

  validateInn(value) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    // проверка на число
    if (value.match(/\D/)) {
      return false
    }

    // проверка на 10 и 12 цифр
    if (value.length !== 12 && value.length !== 10) {
      return false
    }

    if (value === '0000000000' || value === '000000000000') {
      return false
    }

    // проверка по контрольным цифрам
    if (value.length === 10) {

      const dgt10 = String(((
        2 * value[0] + 4 * value[1] + 10 * value[2] +
        3 * value[3] + 5 * value[4] + 9 * value[5] +
        4 * value[6] + 6 * value[7] + 8 * value[8]) % 11) % 10)

      if (value[9] === dgt10) {
        return true
      }

      return false

    }

    if (value.length === 12) {
      const dgt11 = String(((
        7 * value[0] + 2 * value[1] + 4 * value[2] +
        10 * value[3] + 3 * value[4] + 5 * value[5] +
        9 * value[6] + 4 * value[7] + 6 * value[8] +
        8 * value[9]) % 11) % 10)
      const dgt12 = String(((
        3 * value[0] + 7 * value[1] + 2 * value[2] +
        4 * value[3] + 10 * value[4] + 3 * value[5] +
        5 * value[6] + 9 * value[7] + 4 * value[8] +
        6 * value[9] + 8 * value[10]) % 11) % 10)

      if (value[10] === dgt11 && value[11] === dgt12) {
        return true
      }

      return false

    }
  }

  validateSNILS(value) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    const isTrueLength = value.replace(/\D/gm, '').length === 11

    if (!isTrueLength) {
      return false
    }

    const valueClean = value.replace(/-/g, '')
    let valueFinal = valueClean.replace(' ', '')

    const checkSum = parseInt(valueFinal.slice(9), 10)

    // представить строку как массив (для старых браузеров)
    valueFinal = String(valueFinal)
    valueFinal = valueFinal.split('')

    const sum = (
      valueFinal[0] * 9 +
      valueFinal[1] * 8 +
      valueFinal[2] * 7 +
      valueFinal[3] * 6 +
      valueFinal[4] * 5 +
      valueFinal[5] * 4 +
      valueFinal[6] * 3 +
      valueFinal[7] * 2 +
      valueFinal[8] * 1
    )

    if (sum < 100) {
      return sum === checkSum
    }

    if (sum === 100 || sum === 101) {
      return checkSum === 0
    }

    if (sum > 101) {
      return (sum % 101 === checkSum || (sum % 101 === 100 && checkSum === 0))
    }
  }

  validatePhone(value) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    // eslint-disable-next-line
    return String(value).replace(/[ ,(,),\-,+,_]/g, '').length >= 11
  }

  validateRuString(value) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    // eslint-disable-next-line
    const reg = new RegExp('^[А-я|Ё|ё| |-|-|–|—|‒|―]+$')

    return reg.test(value)
  }

  validateRuDotString(value) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    // eslint-disable-next-line
    const reg = new RegExp('^[А-я|Ё|ё|-|-|–|—|‒|―| |\.]+$')

    return reg.test(value)
  }

  validateRuDotNumeric(value) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    if (!~String(value).search(/[А-яЁё]/)) {
      return false
    }

    // eslint-disable-next-line
    const reg = new RegExp('^[А-я|"|№|Ё|ё| |0-9|-|-|–|—|‒|―|\.]+$')

    return reg.test(value)
  }

  validateNumberRuString(value) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    if (!~String(value).search(/[0-9]/)) {
      return false
    }

    // eslint-disable-next-line
    const reg = new RegExp('^[А-я|Ё|ё| |0-9|-|-|–|—|‒|―|\.|/]+$')

    return reg.test(value)
  }

  validateAddress(value) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    // eslint-disable-next-line
    const reg = new RegExp('^[А-я|Ё|ё| |0-9|,|/|-|-|–|—|‒|―|(|)|№\.]+$')

    return reg.test(value)
  }

  validateRuEnString(value) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    // eslint-disable-next-line
    const reg = new RegExp('^[А-я|Ё|ё|A-z| |0-9|,|/|-|-|–|—|‒|―]+$')

    return reg.test(value)
  }

  validateRequired(value) {
    if (Array.isArray(value)) return !!value.length

    if (value === 0 || value === '0') {
      return true
    }

    if (isNil(value)) {
      return false
    }

    // eslint-disable-next-line
    value = String(value).replace(/[ ,(,),\-,\.,+,_]/g, '')

    return value === undefined || value === null
      ? false
      : !!String(value).length
  }

  validateMinLength(value, length) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    if (Array.isArray(value)) return value.length === 0 || value.length >= length

    // eslint-disable-next-line
    value = String(value).replace(/[ ,(,),\-,\.,+,_]/g, '')

    return value === undefined || value === null
      ? true
      : value === '' || String(value).length >= length
  }

  validateMaxLength(value, length) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    // value = String(value).replace(/[ ,(,),\-,+,_]/g, '')

    return String(value).length <= length
  }

  validateEmail(value) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    // eslint-disable-next-line
    const reg = /^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9\-]+\.[a-zA-Z0-9\-.]+$/

    return reg.test(value)
  }

  validateNumber(value) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    value = String(value)
      .replace(/ /g, '')

    return /^[0-9]*$/.test(value)
  }

  validateFloat(value) {

    if (isNil(value) || isEmpty(value)) {
      return true
    }

    value = String(value).replace(/ /g, '')

    return /^-?\d*((\.|,)\d+)?$/.test(value)
  }

  validateYear(value) {

    if (!value || value < 1900 || value > (new Date().getFullYear())) {
      return false
    }

    return /^[0-9]*$/.test(value)
  }

  validateUrl(value) {
    if (isNil(value) || isEmpty(value)) {
      return true
    }

    try {
      new URL(value)
    } catch (e) {
      return false
    }

    return true
  }

  // текст ошибки по типу валидации
  getErrorText(rule, param) {

    switch (rule) {
      case 'required':
        return 'Заполните поле'
      case 'email':
        return 'Некорректный e-mail адрес'
      case 'date':
        return param === 'feature' ? 'Нужна будущая дата' : 'Неверный формат даты'
      case 'numeric':
      case 'number':
      case 'float':
        return 'Принимаем только цифры'
      case 'minLength':
        return `Минимум ${param} ${declOfNum(param, ['символ', 'символа', 'символов'])}`
      case 'maxLength':
        return `Максимум ${param} ${declOfNum(param, ['символ', 'символа', 'символов'])}`
      case 'ruString':
      case 'fio':
        return 'Допустимые символы А-Я, \'-\''
      case 'ruEnString':
        return 'Допустимые символы А-Я, A-Z, \'-\''
      case 'ruDotString':
        return 'Допустимые символы А-Я, \'-\', \'.\''
      case 'ruDotNumeric':
      case 'numberRuString':
        return 'Допустимые символы А-Я, 0-9, /, (, ), \'-\', \'.\''
      case 'address':
        return 'Допустимые символы А-Я, 0-9, \'/\', \'-\', \'.\', \'(\', \')\''
      case 'phone':
      case 'mobilePhone':
        return 'Некорректный номер телефона'
      case 'inn':
        return 'Некорректный ИНН'
      case 'year':
        return 'Некорректный год'
      case 'snils':
        return 'Некорректный СНИЛС'
      case 'firstUpperCase':
        return 'Заполните с заглавной буквы'
      case 'agree':
      case 'personalDataAgree':
        return 'Необходимо дать согласие на обработку персональных данных'
      case 'marketingAgree':
        return 'Необходимо дать согласие на получение информационных материалов'
      case 'age':
        return `Вам должно быть больше ${param} ${declOfNum(param, [' года', ' лет', ' лет'])}`
      case 'organizationName':
        return 'Допустимые символы А-Я, 0-9, -, "'
      case 'passport':
        return 'Некорректная серия паспорта'
      case 'unitCode':
        return 'Некорректный код подразделения'
      default:
        return `Error ${rule}`
    }
  }
}

const validationMixin = {
  data() {
    const options = this.$options

    if (options.computed) {

      const vals = options.computed.formValidation

      if (vals) {
        this._vuelidate2 = new ValidateClass(this)
      }

    }

    return {}
  },
  beforeCreate() {
    const options = this.$options

    if (!options.computed) {
      return
    }

    const vals = options.computed.formValidation

    if (!vals) {
      return
    }

    if (options.computed.$v2) {
      return
    }

    options.computed.$v2 = function () {

      if (!this._vuelidate2) {
        return null
      }

      return this._vuelidate2.data
    }
  },

  created() {
    if (this.formValidation && this._vuelidate2) {
      this._vuelidate2.created()
      this._vuelidate2.setFormRules(this.formValidation)
    }
  },

  beforeDestroy() {
    if (this._vuelidate2) {
      // this._vuelidate2.destroy()
      this._vuelidate2 = null
    }
  },

  watch: {
    formValidation(value) {
      if (this._vuelidate2) {
        this._vuelidate2.setFormRules(value)
      }
    }
  }
}

const Validate2 = (app) => {
  app.mixin(validationMixin)
}

export {ValidateClass, validationMixin, Validate2}
